/* Marquee */
(function ($) {
  $(document).ready(function () {
    if (!$(".em-marquee--container").length) {
      return;
    }

    $(".em-marquee--container").each(function (i) {
      var speed = parseInt($(this).attr("data-speed"));
      var isReverse = $(this).attr("data-reverse");

      var targetElements = $(this).children().children();

      var tween = gsap
        .to(targetElements, {
          xPercent: -100,
          repeat: -1,
          duration: speed,
          ease: "linear",
        })
        .totalProgress(0.5);

      // Set the xPercent of the first child element
      gsap.set($(this).children, { xPercent: -50 });

      gsap.to(tween, {
        timeScale: isReverse ? -1 : -1,
      });
    });
  });
})(jQuery);

(function ($) {
  $(document).ready(function () {
    if (!$(".em-slider--wrapper .swiper").length) {
      return;
    }

    var swiper = new Swiper(".em-slider--wrapper .swiper", {
      loop: true,
      effect: "fade",
      fadeEffect: {
        crossFade: true, // <--- enables crossfade (default is false)
      },
      autoplay: {
        delay: 6000,
        disableOnInteraction: false,
      },
      speed: 1000,
      slidesPerView: 1,
      // Navigation arrows
      navigation: {
        nextEl: ".em-slider--btn .em-slider--btn-next",
        prevEl: ".em-slider--btn .em-slider--btn-prev",
      },
    });
  });
})(jQuery);

(function ($) {
  $(document).ready(function () {
    if (!$(".em-gallery-slider--wrapper .swiper").length) {
      return;
    }

    var swiper = new Swiper(".em-gallery-slider--wrapper .swiper", {
      loop: true,
      autoplay: {
        delay: 1,
        disableOnInteraction: false,
      },
      speed: 15000,
      slidesPerView: 2,
      centeredSliders: true,
      spaceBetween: 20,
      breakpoints: {
        768: {
          slidesPerView: 4,
          spaceBetween: 20,
        },
      },
    });
  });
})(jQuery);

(function($){
	$( document ).ready(function() {
    gsap.registerPlugin(ScrollTrigger);
    
    const timelineContainer = $(
      '#em-timeline--wrapper .em-timeline--item'
    );
    
    timelineContainer.append('<span class="em-tl-line"></span>');
    timelineContainer.prepend('<span class="em-tl-dot"></span>');
    
    timelineContainer.each((_, element) => {
    	const tlParent = $(element);
      
      const tlLine = $(element).children('.em-tl-line');
      const tlDot = $(element).children('.em-tl-dot');
      
      console.log(tlParent);
      
      let tl = gsap.timeline({
        scrollTrigger: {
          trigger: tlParent,
          start: 'top +=50%',
          end: 'bottom center',
          scrub: true,
        },
      });

      tl.from(tlLine, { height: 0, duration: 1 }).from(
        tlDot,
        {
          scale: 0,
          duration: 0.2,
        },
        '-=0.8'
      );
      
      
    });
	});
})(jQuery);  
